import { IObservable, Subject } from '~/rage/utils';
import {
	IJobPromotion,
	Job,
	JobSelectedVehicle,
	JobVehicleRentClass,
	JobVehicleRentCurrency,
	VehicleType,
} from '~/shared';
import { IJobTask } from '../JobTasksService/jobTasksServiceTypes';
import { IJobsService, JobRentVehicleConfig } from './jobsServiceTypes';

export class JobsServiceStub implements IJobsService {
	private readonly promotions = new Subject<IJobPromotion[]>([
		{
			jobId: Job.Farmer,
			promotionEndsAt: Date.now() + 1000 * 60 * 60 * 24,
		},
	]);

	private readonly playerAtWork = new Subject<boolean>(false);

	private readonly rentVehicles = new Subject<JobRentVehicleConfig[]>([
		{
			jobId: Job.Taxi,
			vehicleModel: 'adder',
			vehicleClass: JobVehicleRentClass.Comfort,
			minLevel: 2,
			price: 12345,
			priceCurrency: JobVehicleRentCurrency.Ruble,
		},
	]);

	private readonly withRentVehicles = new Subject<boolean>(true);
	private readonly withOwnedVehicles = new Subject<boolean>(true);
	private readonly allowedVehicleTypes = new Subject<VehicleType[]>([]);

	private readonly openedJobId = new Subject<Job | null>(Job.Farmer);
	private readonly activeJobId = new Subject<Job | null>(Job.Farmer);
	private readonly jobTasksExpireAt = new Subject<number>(
		Date.now() + 1000 * 60 * 60 * 6,
	);
	private readonly jobTasks = new Subject<IJobTask[]>([]);

	public getOpenedJobId(): IObservable<Job | null> {
		return this.openedJobId;
	}

	public getActiveJobId(): IObservable<Job | null> {
		return this.activeJobId;
	}

	public getJobPromotions(): IObservable<IJobPromotion[]> {
		return this.promotions;
	}

	public async setTaskPinnedById(
		taskId: string,
		isPinned: boolean,
	): Promise<void> {
		console.log('setTaskPinnedById', { taskId, isPinned });
	}

	public getPlayerAtWork(): IObservable<boolean> {
		return this.playerAtWork;
	}

	public getRentVehicles(): IObservable<JobRentVehicleConfig[]> {
		return this.rentVehicles;
	}

	public getWithRentVehicles(): IObservable<boolean> {
		return this.withRentVehicles;
	}

	public getWithOwnedVehicles(): IObservable<boolean> {
		return this.withOwnedVehicles;
	}

	public getAllowedVehicleTypes(): IObservable<VehicleType[]> {
		return this.allowedVehicleTypes;
	}

	public getTasks(): IObservable<IJobTask[]> {
		return this.jobTasks;
	}

	public getTasksByJob(_jobId: Job): IObservable<IJobTask[]> {
		return this.jobTasks;
	}

	public getTasksExpireAt(): IObservable<number> {
		return this.jobTasksExpireAt;
	}

	public async startWorkShift(vehicle?: JobSelectedVehicle): Promise<void> {
		const id = this.openedJobId.getValue();
		console.log('startWorkShift', { id, vehicle });
		this.exitMenu();
	}

	public async stopWorkShift(): Promise<void> {
		console.log('stopWorkShift');
	}

	public async exitMenu(): Promise<void> {
		console.log('exitMenu');
	}

	private onApiError() {
		this.exitMenu();
	}
}
